module.exports = __webpack_public_path__ + "img/make-appointment.f3f8e6bd.svg";